import { Component, Input, EventEmitter, Output, SimpleChanges, forwardRef } from '@angular/core';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { AbstractControl, ControlValueAccessor, FormControl, FormGroupDirective, FormsModule, NG_VALUE_ACCESSOR, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-select-search',
  standalone: true,
  imports: [NgxMatSelectSearchModule, MatSelectModule, FormsModule, CommonModule],
  templateUrl: './select-search.component.html',
  styleUrl: './select-search.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectSearchComponent),
      multi: true
    }
  ]
})
export class SelectSearchComponent implements ControlValueAccessor {
  @Input() selectItems: any[] = [];
  @Input() selectTitle!: string;
  @Input() setId!: any;
  isInitialised = false;
  filteredSelectList: any[] = [];
  @Input() isrequired = false;
  @Input() matcher!: ErrorStateMatcher;
  @Input() errorMessage = '';
  selectFilterCtrl: FormControl = new FormControl();
  onTouched = () => { };
  onChange = (_: any) => { };
  @Output() selectedItemId = new EventEmitter<number | null>();
  selectId: number | null = null;
  @Input() invalid = false;
  @Input() disabled = false;
  readonly effectiveMatcher: ErrorStateMatcher = {
    isErrorState: (control: AbstractControl | null, form: FormGroupDirective | NgForm | null): boolean => {
      // If parent explicitly flagged this field invalid → show red border
      if (this.invalid) return true;
      // Otherwise fall back to the passed matcher
      return this.matcher?.isErrorState(control as any, form as any) ?? false;
    }
  };

  onSelectChange(event: MatSelectChange) {
    this.selectId = event.value;
    this.onChange(this.selectId);
    this.onTouched();
    this.notify();
  }

  onDropdownOpenChange(isOpen: boolean): void {
    if (isOpen) {
      this.filteredSelectList = [...this.selectItems];
    }
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(value: any): void {
    this.selectId = value ?? null;
  }

  get showError(): boolean {
    return this.isrequired && this.invalid;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  onSearch(event: Event) {
    const value = (event.target as HTMLInputElement).value.toLowerCase();

    this.filteredSelectList = this.selectItems.filter(p =>
      p.name.toLowerCase().includes(value)
    );
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  notify() {
    this.selectedItemId.emit(this.selectId);
  }

  ngOnInit(){
    this.isInitialised = true;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.filteredSelectList = [...this.selectItems];

    if (changes['selectItems'] && this.selectItems.length === 0) {
      this.selectId = null;
    }

    if (changes['setId'] &&
      changes['setId'].currentValue !== undefined &&
      changes['setId'].currentValue != null) {

      const val: any = changes['setId'].currentValue;

      if (typeof val === 'number' && !isNaN(val)) {
        this.selectId = val;
      } else if (typeof val === 'string') {
        if (val.includes('-')) {
          const parts: string[] = val.split('-');
          if (parts[0] === '') {
            this.selectId = Number(val);
          } else {
            this.selectId = Number(parts[1]);
          }
        } else {
          const parsed = Number(val);
          if (!isNaN(parsed)) {
            this.selectId = parsed;
          }
        }
      }
    }
  }
}
